import { backendRequest } from 'services/request'

export const getRepositories = () => backendRequest({ url: '/repositories/', method: 'GET' })

export const postRepository = (data) => backendRequest({ url: '/repositories/', method: 'POST', data })

export const putRepository = (id, data) => backendRequest({ url: `/repositories/${id}`, method: 'PUT', data })

export const getVolume = (id) => backendRequest({ url: `/repositories/${id}/volume`, method: 'GET' })

export const getScenes = (repositoryId, params = {}) =>
  backendRequest({ url: `/repositories/${repositoryId}/scenes/`, method: 'GET', params })

export const downloadScene = (repositoryId, sceneId, type) =>
  backendRequest({
    url: `/repositories/${repositoryId}/scenes/${sceneId}/download`,
    method: 'GET',
    // The endpoint redirects to the presigned URL by default, for NBSS
    // and for links pasted into a browser. Callers here want the URL
    // itself, to queue or to fetch.
    params: { format: 'json', ...(type ? { type } : {}) }
  })

export const deleteScene = (repositoryId, sceneId) =>
  backendRequest({ url: `/repositories/${repositoryId}/scenes/${sceneId}`, method: 'DELETE' })

export const createTask = (repositoryId, data) =>
  backendRequest({ url: `/repositories/${repositoryId}/tasks/`, method: 'POST', data })

export const ingest = (repositoryId, data) => backendRequest({ url: `/repositories/${repositoryId}/ingest`, method: 'POST', data })
